/**
 * Light/dark switch, in the header beside Refresh.
 *
 * Shows the theme it will switch *to*, which is why the sun appears while the
 * page is dark. A button that shows the current state reads as a status light and
 * gets clicked by people who wanted the other one.
 */
import { Moon, Sun } from 'lucide-react'
import { useTheme } from '../hooks/useTheme'
import { Button } from './ui/Button'

export function ThemeToggle() {
  const { theme, toggle } = useTheme()
  const next = theme === 'dark' ? 'light' : 'dark'

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggle}
      title={`Switch to the ${next} theme`}
      aria-label={`Switch to the ${next} theme`}
      // Square, and `size="sm"` rather than `size="icon"`, so it is the same 32px
      // height as Refresh beside it. `size="icon"` is 36px and stands a row of
      // header controls a few pixels out of line.
      className="w-8 px-0"
    >
      {theme === 'dark' ? (
        <Sun className="h-3.5 w-3.5" />
      ) : (
        <Moon className="h-3.5 w-3.5" />
      )}
    </Button>
  )
}
